import { createFileRoute, redirect } from '@tanstack/react-router'
import { CashSaleForm } from '@/features/accounting-cash-sales/cash-sale-form'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/sales-receipts/$cashSaleId/edit')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad: ({ context, search }) => {
    if (!hasGrant(context.queryClient, 'accounting_cash_sale.edit')) {
      throw redirect({ to: '/accounting/sales-receipts', search })
    }
  },
  component: SalesReceiptEditRoute,
})

function SalesReceiptEditRoute() {
  const { cashSaleId } = Route.useParams()
  return <CashSaleForm saleId={cashSaleId} />
}
